import {useState, useContext, useRef } from 'react';
import html2canvas from 'html2canvas';
import Blur from './util/Blur'
import CloseButton from './CloseButton';
import { ToastContext } from './context/ToastContext';

const Screenshot = ({day}) => {

	const [open, setOpen] = useState(false);
	const [img, setImg] = useState(null);
	const { showToast } = useContext(ToastContext);
	const screenshotWindowRef = useRef(null);

	const handleKeyPress = (event) => {
        if (event.key === 'Escape') {
			handleScreenshotWindowClose();
        }
    };

    const captureScreenshot = () => {
		if (img) {
			setOpen(true);
			document.body.style.overflow = 'hidden';
			return;
		};

        const grid = document.getElementById('grid');
        const score = document.getElementById('score-image');

        const imageDiv = document.createElement('div');
        imageDiv.id = "share-grid-image";
        imageDiv.style.zIndex = -5;
		imageDiv.style.position = "absolute";
		imageDiv.style.display = "flex";
		imageDiv.style.flexDirection = "column";
		imageDiv.style.alignItems = "center";
		// imageDiv.style.borderLeft = "1px solid black";
		// imageDiv.style.borderRight = "1px solid black";
		// imageDiv.style.borderBottom = "1px solid black";


		const gridForScreenshot = grid.cloneNode(true);
		const scoreForScreenshot = score.cloneNode(true);

		// scoreForScreenshot.style.width = "100%"
		// scoreForScreenshot.style.borderBottom = "1px solid black";
		// scoreForScreenshot.style.borderLeft = "1px solid black";
		// scoreForScreenshot.style.borderRight = "1px solid black";

		// particles gif is not opaque and covers cells in screenshot 
		let bigParticlesCells = gridForScreenshot.getElementsByClassName('big-particles');
		let smallParticlesCells = gridForScreenshot.getElementsByClassName('light-particles');
		console.log(bigParticlesCells.length, smallParticlesCells.length);
		for (let i = bigParticlesCells.length - 1; i >= 0;  i--) {
			bigParticlesCells[i].className = 'no-particles';
		}
		for (let i = smallParticlesCells.length - 1; i >= 0;  i--) {
			smallParticlesCells[i].className = 'no-particles';
		}

		console.log(bigParticlesCells);

		scoreForScreenshot.style.paddingTop = "2px";
		gridForScreenshot.style.width = "768px";
		gridForScreenshot.style.height = "768px"; 
        imageDiv.appendChild(gridForScreenshot);
        imageDiv.appendChild(scoreForScreenshot); 


        document.body.appendChild(imageDiv);
        html2canvas(imageDiv, {allowTaint: true, useCORS: true, logging: false, removeContainer: true, width:768, height:808, scale:1}).then(canvas => {            // const link = document.createElement('a');
            setImg(canvas.toDataURL('image/png'));

     	}).then(() => {
			setOpen(true);
        	imageDiv.remove();
			document.body.style.overflow = 'hidden';
      	});
	
	}	
    
	const downloadImage = (event) => {
		let { top, left } = event.target.getBoundingClientRect();
		top = top - 15;
		left = left - 5;
		let link = document.createElement('a');
		link.download = `SPOILER_FateGrid${day}.png`;
		link.href = img;
		link.click();
		showToast('Screenshot downloaded!', { top, left });
	
	}

	
	const copyToClipboard = async (event) => {
		let { top, left } = event.target.getBoundingClientRect();
		top = top - 15;
		left = left - 5;
		try {
			// Copy the image to clipboard
			if (img) {
				// Fetch the image
				const response = await fetch(img);
				const blob = await response.blob();
			
				// Use the Clipboard API to copy the image
				await navigator.clipboard.write([
				new ClipboardItem({
					[blob.type]: blob
				})
				]);
			}
			showToast('Screenshot copied!', { top, left });
		} catch (e) {
			// showToast('Error, could not copy to clipboard', { top, left });
			window.alert("Error, could not copy to clipboard. Some browsers do not support copying images to clipboard. Manually copy the image by right-click/holding the image.")
			// console.log("something went wrong", event);
		}

	};

	const handleScreenshotWindowClose = () => {
		setOpen(false)
		document.body.style.overflow = 'auto';
	}

  	return (
		<div>
			<button data-tooltip-id='screenshotTip' className="score-button" onClick={captureScreenshot} ref={screenshotWindowRef} onKeyDown={handleKeyPress}>📷 Screenshot</button>
			{open && <div>
				<Blur onClick={handleScreenshotWindowClose} />
			<div className='panel' style={{padding:"10px"}}>
				<CloseButton onClose={handleScreenshotWindowClose}/>
				<h1>Screenshot</h1> 
				<img src={img} width={"90%"}/>
				<button className="score-button" onClick={downloadImage}>📂 Download</button>
				<button className="score-button" onClick={copyToClipboard}>📃 Copy</button> </div>
			</div>}

		</div>
  	);
}

export default Screenshot;
